import CryptoJS from 'crypto-js';
import { APP_PREFIX, CDN_PUBLIC_KEY, TOKEN_KEY } from '../actions/variables';
import { UserModel } from '../models';

export const getUserModel = () => {
  let user = localStorage.getItem(`${APP_PREFIX}_USER`);
  if(!user) return new UserModel();
  try {
    let bytes = CryptoJS.AES.decrypt(user, TOKEN_KEY);
    user = bytes.toString(CryptoJS.enc.Utf8);
    return new UserModel(user? JSON.parse(user): {});
  } catch {
    return new UserModel();
  }
};

export const apiHeader = () => {
  const temp = localStorage.getItem(`${APP_PREFIX}_ACCESS`);
  if(temp){
    const bytes = CryptoJS.AES.decrypt(temp, TOKEN_KEY);
    const accessToken = bytes.toString(CryptoJS.enc.Utf8);
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    };
  }else{
    return { 'Content-Type': 'application/json' };
  }
};

export const apiHeaderFormData = (accept='image/png,image/jpeg,image/jpg', bypass=false) => {
  let user = getUserModel();
  if(user.isSignedIn() || bypass){
    return {
      'Authorization': `Bearer ${CDN_PUBLIC_KEY}`,
      'Accept-Mimetypes': accept,
    };
  }else{
    return {};
  }
};
